import consumer from "./consumer"

/**
 * Create a subscription to a conversation channel
 * @param {number|string} conversationId - The ID of the conversation
 * @param {object} handlers - Object containing event handlers for the subscription
 * @returns {object} - The ActionCable subscription object
 */
export function createConversationSubscription(conversationId, handlers = {}) {
  if (!conversationId) {
    console.error("Cannot create subscription: conversation ID is required");
    return null;
  }

  // Default handlers
  const defaultHandlers = {
    connected: () => console.log(`Connected to conversation ${conversationId} channel`),
    disconnected: () => console.log(`Disconnected from conversation ${conversationId} channel`),
    received: (data) => console.log(`Received data from conversation ${conversationId}:`, data)
  };

  // Merge default handlers with custom handlers
  const mergedHandlers = { ...defaultHandlers, ...handlers };

  return consumer.subscriptions.create(
    {
      channel: "ConversationChannel",
      conversation_id: conversationId
    },
    mergedHandlers
  );
}

// Export the consumer for direct use if needed
export { consumer };